export const CONSTRAINTS = {
  MAX_DESCRIPTION_LENGTH: 165,
  MAX_TITLE_LENGTH: 60,
  MAX_PATH_LENGTH: 60,
};

export const VALID_SITE_URL = /^[a-zA-Z0-9\-_]*$/;
